import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import _ from 'lodash'
import { actions } from '../../redux/modules/templatesActions'
import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'
import { actions as auditActions } from '../../redux/modules/auditActions'
import EstimateTemplateForm from '../../components/templates/EstimateTemplateForm'

const Container = styled.div`
  padding: 25px;
`
const propTypes = {}

class TemplatesEstimate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentKey: 'estimate',
      modalIsShowing: false,
      currentId: +this.props.match.params.templateId,
      contentData: null
    }
    if (+this.props.match.params.templateId > 0) {
      this.props.getAuditRevisions({
        targetId: +this.props.match.params.templateId,
        table: 'estimate_template'
      })
    }
  }

  componentDidMount() {
    this.props.getTemplateById({
      templateType: this.state.currentKey,
      templateId: this.state.currentId
    })

    this.props.getAllItems()
  }

  handleCreate = formData => {
    const { currentId } = this.state
    const { estimateData, estimateTotals } = formData
    const estimateCounts = {
      overhead_total: estimateTotals ? estimateTotals.overhead_total : 0,
      grand_total: estimateTotals ? estimateTotals.grand_total : 0
    }

    if (currentId === 0) {
      this.props.createTemplate({
        templateType: this.state.currentKey,
        content: estimateData,
        estimateSections: formData.estimateSections,
        estimateCounts,
        userId: this.props.authentication.user.userId
      })
    } else {
      this.props.saveTemplate({
        templateId: this.state.currentId,
        templateType: this.state.currentKey,
        content: estimateData,
        estimateSections: formData.estimateSections,
        estimateCounts,
        userId: this.props.authentication.user.userId
      })
    }
  }

  confirmDelete = () => {
    this.props.deleteTemplate({
      templateId: this.state.currentId,
      templateType: this.state.currentKey
    })

    this.setState({
      currentId: 0
    })
  }
  prepareDataStructure = () => {
    const templateSectionsAndItems = _.get(this.props, 'templatesActions.loadedTemplate.data')
    const sections = _.get(templateSectionsAndItems, 'template_sections')
    const items = _.get(templateSectionsAndItems, 'template_items')

    if (sections && sections.length > 0) {
      if (sections.length > 0 && items && items.length > 0) {
        let groupedItems = sections.map((section, index) => {
          section.items = items.filter(item => {
            return item.estimate_section_template_id === section.id
          })
          return section
        })

        // sort by order
        const sortedGroupedItems = _.sortBy(groupedItems, section => {
          const sortedItems = _.sortBy(section.items, item => {
            return item.order
          })

          section.items = sortedItems

          return section.order
        })

        return sortedGroupedItems
      }
    }

    return []
  }

  render() {
    const { currentId } = this.state
    const items = _.get(this.props, 'itemActions.allItems.data')
    const loadedTemplate = _.get(this.props, 'templatesActions.loadedTemplate')
    const templateInfo = _.get(this.props, 'templatesActions.loadedTemplate.data.template_info')
    const revisions = _.get(this.props, 'auditActions.revisions.data')
    const loadingRevision = this.props.auditActions && this.props.auditActions.loading
    const dataStructure = this.prepareDataStructure()
    if (!loadedTemplate || !items) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <Container>
          <EstimateTemplateForm
            currentId={currentId}
            templateInfo={templateInfo}
            dataStructure={dataStructure}
            items={items || []}
            onCreate={this.handleCreate}
            handleDelete={this.confirmDelete}
            revisions={revisions}
            loadingRevision={loadingRevision}
          />
        </Container>
      )
    }
  }
}

const mapStateToProps = (
  { templatesActions, itemActions, authentication, auditActions },
  ownProps
) => {
  return {
    templatesActions,
    itemActions,
    authentication,
    auditActions
  }
}
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, itemActions, auditActions), dispatch)
})

TemplatesEstimate.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplatesEstimate))



// WEBPACK FOOTER //
// ./src/containers/templates/estimateTemplate.js